import { useMemo, useContext } from 'react'
import { observer } from 'mobx-react'
import { NativeTable, ListTableContext } from 'src/components'
import { pick, set } from 'lodash'

const ListTableNative = () => {
  const state = useContext(ListTableContext)

  const columns = useMemo(() => {
    const data = state.tableData.columns ?? []
    return data.map((item: any) => {
      const common = pick(item, ['title', 'dataIndex'])
      item.config?.WIDTH && set(common, 'width', item.config.WIDTH)
      return common
    })
  }, [state.tableData.columns])

  return (
    <div className='full-parent'>
      <NativeTable columns={columns} dataSource={state.tableData.dataSource} />
    </div>
  )
}

export default observer(ListTableNative)